export default __webpack_public_path__ + "static/screen_3_03-c2dab99ca84893ffc41b3cc87f9d2b50.svg";